module.exports = __webpack_public_path__ + "static/img/4.cd3870d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/4.png
// module id = ELY9
// module chunks = 1